"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortedSocialNetworks = void 0;

/**
 * Export `sortedSocialNetworks`.
 */
var sortedSocialNetworks = ['twitter', 'airchat', 'facebook', 'instagram', 'linkedin', 'tiktok', 'slack', 'telegram', 'discord', 'medium', 'substack'];
exports.sortedSocialNetworks = sortedSocialNetworks;